module.exports = __webpack_public_path__ + "static/img/baners.00043b90.jpg";